<template>
  <div class="post-webwidget-v2-player-layout" :class="layoutClassList">
    <div class="post-webwidget-v2-player-layout-top">
      <slot name="top-half"></slot>
    </div>
    <div class="post-webwidget-v2-player-layout-bottom">
      <slot name="bottom-half"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'v2-player-layout',
  props: {
    darkTheme: Boolean,
    compactOnMobile: Boolean,
  },
  computed: {
    layoutClassList() {
      return {
        'post-webwidget-v2-player-layout--dark-theme': this.darkTheme,
      };
    },
  },
};
</script>
<style lang="scss" scoped>
@import '../assets/variables-v2';
.post-webwidget-v2-player-layout {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  font-size: 14px;
  max-width: 600px;
  color: $color;
  // border: 1px solid $borderColor;
  box-shadow: 0px 1px 1px $borderColor;
  background: $playerBackground;
  border-radius: $borderRadius;

  * {
    transition: all .2s;
  }
  
  &-top {
    padding: 0.5em;
    &--compact-on-mobile {
      padding: 0.5em;
    }

    @media screen and (max-width: $mobileBreakpoint) {
      padding: 0;
      &--compact-on-mobile {
        padding: 0.5em;
      }
    }
  }

  &-bottom {
    padding: 0.5em;
  }
  
  /** Dark theme **/
  &--dark-theme {
    border-color: $darkThemeBorderColor;
    color: $darkThemeColor;
    background: $darkThemePlayerBackground;
  }
}
</style>


// WEBPACK FOOTER //
// V2PlayerLayout.vue?29e5825c